import { Expose, Type } from '@nts/std/serialization';
import { CustomReportItemIdentity } from "./custom-report/custom-report-item.identity";
import { StandardReportIdentity } from "./standard-report/standard-report.identity";
import { CustomReportItemIdentityInterface, ReportFileSelectionDtoInterface, StandardReportIdentityInterface } from '@nts/std/interfaces';

export class ReportFileSelectionDto implements ReportFileSelectionDtoInterface {

    constructor() {
        this.standardReportIdentity = new StandardReportIdentity();
        this.customReportItemIdentity = new CustomReportItemIdentity();
    }

    @Expose()
    @Type(() => StandardReportIdentity)
    standardReportIdentity: StandardReportIdentityInterface;

    @Expose()
    @Type(() => CustomReportItemIdentity)
    customReportItemIdentity: CustomReportItemIdentityInterface;
}
